/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EfsMelcoEfsModelsEfsDefaultFormat,
    EfsMelcoEfsModelsEfsDefaultFormatFromJSON,
    EfsMelcoEfsModelsEfsDefaultFormatFromJSONTyped,
    EfsMelcoEfsModelsEfsDefaultFormatToJSON,
    EfsMelcoModelsCustomWarning,
    EfsMelcoModelsCustomWarningFromJSON,
    EfsMelcoModelsCustomWarningFromJSONTyped,
    EfsMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface EfsMelcoModelsGenericList1MelcoEfsModelsEfsDefaultFormat
 */
export interface EfsMelcoModelsGenericList1MelcoEfsModelsEfsDefaultFormat {
    /**
     * 
     * @type {Array<EfsMelcoEfsModelsEfsDefaultFormat>}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsEfsDefaultFormat
     */
    list: Array<EfsMelcoEfsModelsEfsDefaultFormat>;
    /**
     * 
     * @type {Array<EfsMelcoModelsCustomWarning>}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsEfsDefaultFormat
     */
    warning_list?: Array<EfsMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsEfsDefaultFormat
     */
    total: number;
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsEfsDefaultFormatFromJSON(json: any): EfsMelcoModelsGenericList1MelcoEfsModelsEfsDefaultFormat {
    return EfsMelcoModelsGenericList1MelcoEfsModelsEfsDefaultFormatFromJSONTyped(json, false);
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsEfsDefaultFormatFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoModelsGenericList1MelcoEfsModelsEfsDefaultFormat {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(EfsMelcoEfsModelsEfsDefaultFormatFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(EfsMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsEfsDefaultFormatToJSON(value?: EfsMelcoModelsGenericList1MelcoEfsModelsEfsDefaultFormat | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(EfsMelcoEfsModelsEfsDefaultFormatToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(EfsMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


